import { render, staticRenderFns } from "./FeishuAuthorizationCard.vue?vue&type=template&id=5fcbaa1b&scoped=true"
import script from "./FeishuAuthorizationCard.vue?vue&type=script&lang=js"
export * from "./FeishuAuthorizationCard.vue?vue&type=script&lang=js"
import style0 from "./FeishuAuthorizationCard.vue?vue&type=style&index=0&id=5fcbaa1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcbaa1b",
  null
  
)

export default component.exports